import { render, staticRenderFns } from "./PopularActivities.vue?vue&type=template&id=138d25f5&scoped=true&"
import script from "./PopularActivities.vue?vue&type=script&lang=js&"
export * from "./PopularActivities.vue?vue&type=script&lang=js&"
import style0 from "./PopularActivities.vue?vue&type=style&index=0&id=138d25f5&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "138d25f5",
  null
  
)

export default component.exports